var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircleFillGrey = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.9987 14.6663C4.3168 14.6663 1.33203 11.6815 1.33203 7.99967C1.33203 4.31777 4.3168 1.33301 7.9987 1.33301C11.6806 1.33301 14.6654 4.31777 14.6654 7.99967C14.6654 11.6815 11.6806 14.6663 7.9987 14.6663ZM7.9987 7.05687L6.11308 5.17125L5.17027 6.11405L7.0559 7.99967L5.17027 9.88527L6.11308 10.8281L7.9987 8.94247L9.8843 10.8281L10.8271 9.88527L8.9415 7.99967L10.8271 6.11405L9.8843 5.17125L7.9987 7.05687Z",
  fill: "#BDBDBD"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircleFillGrey);
export { ForwardRef as ReactComponent };